export const AGREEMENT_FETCH = 'AGREEMENT_FETCH';
export const ACCOUNT_GOS_AGREEMENT_TRANSACTIONS_LIST_FETCH =
  'ACCOUNT_GOS_AGREEMENT_TRANSACTIONS_LIST_FETCH';
export const AGREEMENT_TRANSACTION_TRANSPORT_STATISTICS_FETCH =
  'AGREEMENT_TRANSACTION_TRANSPORT_STATISTICS_FETCH';
